import Emitter from "es6-event-emitter";
import CookieManager from "./../utilities/cookiemanager";
import { PAYWALL_REDIRECTION } from "./../../common/utilities/redirectorKeys";
import { getFullPaywallRedirectionUrl } from "./../utilities/utils";
import APIManager from "./../../common/utilities/apimanager";
import { hideLoaderAndChangeLocation } from "../utilities/location";

export default class ExternalPaywall extends Emitter {
  constructor(internalPaywall, options, authenticatorAuthorisationController) {
    super();
    this.internalPaywall = internalPaywall;
    this.options = options;
    this.authenticatorAuthorisationController =
      authenticatorAuthorisationController;
  }

  get currentNumberOfRedirection() {
    return CookieManager.getNumberOfRedirects();
  }

  isValidPaywallRedirectionProfileValue = (userProfileValue) => {
    const redirectionUrl =
      userProfileValue && userProfileValue[0] && userProfileValue[0].Value;

    return redirectionUrl && redirectionUrl !== "";
  };

  getUrlAndRedirect = (
    publicationData,
    updateNumberOfExternalPaywallRedirection = true
  ) => {
    APIManager.getUserProfileValue(PAYWALL_REDIRECTION)
      .then((response) => {
        if (!this.isValidPaywallRedirectionProfileValue(response)) {
          this.internalPaywall.show(publicationData, false);
          return;
        }
        if (updateNumberOfExternalPaywallRedirection) {
          CookieManager.setNumberOfRedirects(
            this.currentNumberOfRedirection + 1,
            this.options.paywallRedirectionTimeReset
          );
        }

        const url = response[0].Value;

        hideLoaderAndChangeLocation(
          getFullPaywallRedirectionUrl(
            url,
            this.authenticatorAuthorisationController,
            this.options,
            publicationData
          ),
          window
        );
      })
      .catch(() => {
        this.internalPaywall.show(publicationData, false);
      });
  };
}



// WEBPACK FOOTER //
// ./src/common/components/externalPaywall.js